import { render, staticRenderFns } from "./DialogRegistriMacchina.vue?vue&type=template&id=35ecc4ca&"
import script from "./DialogRegistriMacchina.vue?vue&type=script&lang=js&"
export * from "./DialogRegistriMacchina.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports